import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './button-link-base.css.js';
import '../Icon/wrapped-icons/IconAccountActive.js';
import '../Icon/wrapped-icons/IconAccount.js';
import '../Icon/wrapped-icons/IconAddCircleActive.js';
import '../Icon/wrapped-icons/IconAddCircle.js';
import '../Icon/wrapped-icons/IconAddThick.js';
import '../Icon/wrapped-icons/IconAdd.js';
import '../Icon/wrapped-icons/IconAlertActive.js';
import '../Icon/wrapped-icons/IconAlert.js';
import '../Icon/wrapped-icons/IconAssetsActive.js';
import '../Icon/wrapped-icons/IconAssets.js';
import '../Icon/wrapped-icons/IconBack.js';
import '../Icon/wrapped-icons/IconBarcode.js';
import '../Icon/wrapped-icons/IconBlockActive.js';
import '../Icon/wrapped-icons/IconBlock.js';
import '../Icon/wrapped-icons/IconBorrowingActive.js';
import '../Icon/wrapped-icons/IconBorrowing.js';
import '../Icon/wrapped-icons/IconCalculatorCurrencyActive.js';
import '../Icon/wrapped-icons/IconCalculatorCurrency.js';
import '../Icon/wrapped-icons/IconCalendarActive.js';
import '../Icon/wrapped-icons/IconCalendar.js';
import '../Icon/wrapped-icons/IconCameraActive.js';
import '../Icon/wrapped-icons/IconCamera.js';
import '../Icon/wrapped-icons/IconCardActive.js';
import '../Icon/wrapped-icons/IconCardManageActive.js';
import '../Icon/wrapped-icons/IconCardManage.js';
import '../Icon/wrapped-icons/IconCardReportActive.js';
import '../Icon/wrapped-icons/IconCardReport.js';
import '../Icon/wrapped-icons/IconCard.js';
import '../Icon/wrapped-icons/IconChatAiActive.js';
import '../Icon/wrapped-icons/IconChatAi.js';
import '../Icon/wrapped-icons/IconChequeDepositActive.js';
import '../Icon/wrapped-icons/IconChequeDeposit.js';
import '../Icon/wrapped-icons/IconChevronDoubleDownThick.js';
import '../Icon/wrapped-icons/IconChevronDoubleDown.js';
import '../Icon/wrapped-icons/IconChevronDoubleLeftThick.js';
import '../Icon/wrapped-icons/IconChevronDoubleLeft.js';
import '../Icon/wrapped-icons/IconChevronDoubleRightThick.js';
import '../Icon/wrapped-icons/IconChevronDoubleRight.js';
import '../Icon/wrapped-icons/IconChevronDoubleUpThick.js';
import '../Icon/wrapped-icons/IconChevronDoubleUp.js';
import '../Icon/wrapped-icons/IconChevronDownThick.js';
import '../Icon/wrapped-icons/IconChevronDown.js';
import '../Icon/wrapped-icons/IconChevronLeftThick.js';
import '../Icon/wrapped-icons/IconChevronLeft.js';
import '../Icon/wrapped-icons/IconChevronRightThick.js';
import '../Icon/wrapped-icons/IconChevronRight.js';
import '../Icon/wrapped-icons/IconChevronUpThick.js';
import '../Icon/wrapped-icons/IconChevronUp.js';
import '../Icon/wrapped-icons/IconClearActive.js';
import '../Icon/wrapped-icons/IconClear.js';
import '../Icon/wrapped-icons/IconClientManagementActive.js';
import '../Icon/wrapped-icons/IconClientManagement.js';
import '../Icon/wrapped-icons/IconCloseThick.js';
import '../Icon/wrapped-icons/IconClose.js';
import '../Icon/wrapped-icons/IconCollapse.js';
import '../Icon/wrapped-icons/IconComposeActive.js';
import '../Icon/wrapped-icons/IconCompose.js';
import '../Icon/wrapped-icons/IconContactAddressBookActive.js';
import '../Icon/wrapped-icons/IconContactAddressBook.js';
import '../Icon/wrapped-icons/IconContactChatActive.js';
import '../Icon/wrapped-icons/IconContactChat.js';
import '../Icon/wrapped-icons/IconContactComplaint.js';
import '../Icon/wrapped-icons/IconContactLiveChatActive.js';
import '../Icon/wrapped-icons/IconContactLiveChat.js';
import '../Icon/wrapped-icons/IconContactMessageActive.js';
import '../Icon/wrapped-icons/IconContactMessage.js';
import '../Icon/wrapped-icons/IconContactPhoneActive.js';
import '../Icon/wrapped-icons/IconContactPhone.js';
import '../Icon/wrapped-icons/IconContactScreenShare.js';
import '../Icon/wrapped-icons/IconContactVideo.js';
import '../Icon/wrapped-icons/IconContactVirtualActive.js';
import '../Icon/wrapped-icons/IconContactVirtual.js';
import '../Icon/wrapped-icons/IconContactlessActive.js';
import '../Icon/wrapped-icons/IconContactless.js';
import '../Icon/wrapped-icons/IconControlBackward.js';
import '../Icon/wrapped-icons/IconControlForward.js';
import '../Icon/wrapped-icons/IconControlPause.js';
import '../Icon/wrapped-icons/IconControlPlay.js';
import '../Icon/wrapped-icons/IconCopy.js';
import '../Icon/wrapped-icons/IconDashboardActive.js';
import '../Icon/wrapped-icons/IconDashboard.js';
import '../Icon/wrapped-icons/IconDataChartActive.js';
import '../Icon/wrapped-icons/IconDataChart.js';
import '../Icon/wrapped-icons/IconDeleteActive.js';
import '../Icon/wrapped-icons/IconDelete.js';
import '../Icon/wrapped-icons/IconDeviceAll.js';
import '../Icon/wrapped-icons/IconDeviceDesktop.js';
import '../Icon/wrapped-icons/IconDeviceMobile.js';
import '../Icon/wrapped-icons/IconDeviceTablet.js';
import '../Icon/wrapped-icons/IconDialActive.js';
import '../Icon/wrapped-icons/IconDial.js';
import '../Icon/wrapped-icons/IconDiningActive.js';
import '../Icon/wrapped-icons/IconDining.js';
import '../Icon/wrapped-icons/IconDirectionDown.js';
import '../Icon/wrapped-icons/IconDirectionLeft.js';
import '../Icon/wrapped-icons/IconDirectionRight.js';
import '../Icon/wrapped-icons/IconDirectionSwitch.js';
import '../Icon/wrapped-icons/IconDirectionUp.js';
import '../Icon/wrapped-icons/IconDoNotView.js';
import '../Icon/wrapped-icons/IconDocumentArticle.js';
import '../Icon/wrapped-icons/IconDocumentConfidential.js';
import '../Icon/wrapped-icons/IconDocumentEStatement.js';
import '../Icon/wrapped-icons/IconDocumentPdf.js';
import '../Icon/wrapped-icons/IconDocument.js';
import '../Icon/wrapped-icons/IconDollarBillActive.js';
import '../Icon/wrapped-icons/IconDollarBill.js';
import '../Icon/wrapped-icons/IconDownload.js';
import '../Icon/wrapped-icons/IconEditActive.js';
import '../Icon/wrapped-icons/IconEdit.js';
import '../Icon/wrapped-icons/IconEducationActive.js';
import '../Icon/wrapped-icons/IconEducationBookActive.js';
import '../Icon/wrapped-icons/IconEducationBook.js';
import '../Icon/wrapped-icons/IconEducation.js';
import '../Icon/wrapped-icons/IconExpand.js';
import '../Icon/wrapped-icons/IconExport.js';
import '../Icon/wrapped-icons/IconFastTrackActive.js';
import '../Icon/wrapped-icons/IconFastTrack.js';
import '../Icon/wrapped-icons/IconFavouritePinActive.js';
import '../Icon/wrapped-icons/IconFavouritePin.js';
import '../Icon/wrapped-icons/IconFavouriteStarActive.js';
import '../Icon/wrapped-icons/IconFavouriteStar.js';
import '../Icon/wrapped-icons/IconFileAttachment.js';
import '../Icon/wrapped-icons/IconFilterActive.js';
import '../Icon/wrapped-icons/IconFilterDown.js';
import '../Icon/wrapped-icons/IconFilterUp.js';
import '../Icon/wrapped-icons/IconFilter.js';
import '../Icon/wrapped-icons/IconFxActive.js';
import '../Icon/wrapped-icons/IconFx.js';
import '../Icon/wrapped-icons/IconGlobalActive.js';
import '../Icon/wrapped-icons/IconGlobal.js';
import '../Icon/wrapped-icons/IconGoalsActive.js';
import '../Icon/wrapped-icons/IconGoals.js';
import '../Icon/wrapped-icons/IconHealthActive.js';
import '../Icon/wrapped-icons/IconHealth.js';
import '../Icon/wrapped-icons/IconHelpActive.js';
import '../Icon/wrapped-icons/IconHelp.js';
import '../Icon/wrapped-icons/IconHomeActive.js';
import '../Icon/wrapped-icons/IconHome.js';
import '../Icon/wrapped-icons/IconInsightActive.js';
import '../Icon/wrapped-icons/IconInsight.js';
import '../Icon/wrapped-icons/IconInsuranceActive.js';
import '../Icon/wrapped-icons/IconInsurance.js';
import '../Icon/wrapped-icons/IconIntranet.js';
import '../Icon/wrapped-icons/IconInvestmentActive.js';
import '../Icon/wrapped-icons/IconInvestmentMarketActive.js';
import '../Icon/wrapped-icons/IconInvestmentMarket.js';
import '../Icon/wrapped-icons/IconInvestmentQuoteActive.js';
import '../Icon/wrapped-icons/IconInvestmentQuote.js';
import '../Icon/wrapped-icons/IconInvestment.js';
import '../Icon/wrapped-icons/IconLinkActive.js';
import '../Icon/wrapped-icons/IconLink.js';
import '../Icon/wrapped-icons/IconLiquidityManagementActive.js';
import '../Icon/wrapped-icons/IconLiquidityManagement.js';
import '../Icon/wrapped-icons/IconLocationActive.js';
import '../Icon/wrapped-icons/IconLocation.js';
import '../Icon/wrapped-icons/IconMemo.js';
import '../Icon/wrapped-icons/IconMenuActive.js';
import '../Icon/wrapped-icons/IconMenuMoreHorizontalActive.js';
import '../Icon/wrapped-icons/IconMenuMoreHorizontal.js';
import '../Icon/wrapped-icons/IconMenuMoreVerticalActive.js';
import '../Icon/wrapped-icons/IconMenuMoreVertical.js';
import '../Icon/wrapped-icons/IconMenu.js';
import '../Icon/wrapped-icons/IconMinimise.js';
import '../Icon/wrapped-icons/IconNewModal.js';
import IconNewWindow from '../Icon/wrapped-icons/IconNewWindow.js';
import '../Icon/wrapped-icons/IconNewspaper.js';
import '../Icon/wrapped-icons/IconOnlineBanking.js';
import '../Icon/wrapped-icons/IconPaymentActive.js';
import '../Icon/wrapped-icons/IconPaymentByAliasActive.js';
import '../Icon/wrapped-icons/IconPaymentByAlias.js';
import '../Icon/wrapped-icons/IconPaymentDirectDebit.js';
import '../Icon/wrapped-icons/IconPaymentInternationalActive.js';
import '../Icon/wrapped-icons/IconPaymentInternational.js';
import '../Icon/wrapped-icons/IconPaymentPersonActive.js';
import '../Icon/wrapped-icons/IconPaymentPerson.js';
import '../Icon/wrapped-icons/IconPaymentScheduledActive.js';
import '../Icon/wrapped-icons/IconPaymentScheduled.js';
import '../Icon/wrapped-icons/IconPayment.js';
import '../Icon/wrapped-icons/IconPaymentsAndTransfersActive.js';
import '../Icon/wrapped-icons/IconPaymentsAndTransfers.js';
import '../Icon/wrapped-icons/IconPersonalFinanceManagementActive.js';
import '../Icon/wrapped-icons/IconPersonalFinanceManagement.js';
import '../Icon/wrapped-icons/IconPortfolioActive.js';
import '../Icon/wrapped-icons/IconPortfolio.js';
import '../Icon/wrapped-icons/IconPositionDown.js';
import '../Icon/wrapped-icons/IconPositionUp.js';
import '../Icon/wrapped-icons/IconPresentation.js';
import '../Icon/wrapped-icons/IconPrintActive.js';
import '../Icon/wrapped-icons/IconPrint.js';
import '../Icon/wrapped-icons/IconProductsAndServicesActive.js';
import '../Icon/wrapped-icons/IconProductsAndServices.js';
import '../Icon/wrapped-icons/IconQrCodeActive.js';
import '../Icon/wrapped-icons/IconQrCode.js';
import '../Icon/wrapped-icons/IconQrScannerActive.js';
import '../Icon/wrapped-icons/IconQrScanner.js';
import '../Icon/wrapped-icons/IconRatesActive.js';
import '../Icon/wrapped-icons/IconRates.js';
import '../Icon/wrapped-icons/IconRefresh.js';
import '../Icon/wrapped-icons/IconRenew.js';
import '../Icon/wrapped-icons/IconReplyActive.js';
import '../Icon/wrapped-icons/IconReply.js';
import '../Icon/wrapped-icons/IconReport.js';
import '../Icon/wrapped-icons/IconRewardActive.js';
import '../Icon/wrapped-icons/IconReward.js';
import '../Icon/wrapped-icons/IconRoboAdviceActive.js';
import '../Icon/wrapped-icons/IconRoboAdvice.js';
import '../Icon/wrapped-icons/IconSaveActive.js';
import '../Icon/wrapped-icons/IconSave.js';
import '../Icon/wrapped-icons/IconSavingActive.js';
import '../Icon/wrapped-icons/IconSaving.js';
import '../Icon/wrapped-icons/IconScript.js';
import '../Icon/wrapped-icons/IconSearchActive.js';
import '../Icon/wrapped-icons/IconSearch.js';
import '../Icon/wrapped-icons/IconSecurityDigitalIdentity.js';
import '../Icon/wrapped-icons/IconSecurityEntitlementsActive.js';
import '../Icon/wrapped-icons/IconSecurityEntitlements.js';
import '../Icon/wrapped-icons/IconSecurityEnviornmentActive.js';
import '../Icon/wrapped-icons/IconSecurityEnvironment.js';
import '../Icon/wrapped-icons/IconSecurityFace.js';
import '../Icon/wrapped-icons/IconSecurityFingerprint.js';
import '../Icon/wrapped-icons/IconSecurityHsbcServicesActive.js';
import '../Icon/wrapped-icons/IconSecurityHsbcServices.js';
import '../Icon/wrapped-icons/IconSecurityPassword.js';
import '../Icon/wrapped-icons/IconSecuritySecureActive.js';
import '../Icon/wrapped-icons/IconSecuritySecureKey.js';
import '../Icon/wrapped-icons/IconSecuritySecure.js';
import '../Icon/wrapped-icons/IconSecuritySettingsActive.js';
import '../Icon/wrapped-icons/IconSecuritySettings.js';
import '../Icon/wrapped-icons/IconSettingsActive.js';
import '../Icon/wrapped-icons/IconSettings.js';
import '../Icon/wrapped-icons/IconShareAndroidActive.js';
import '../Icon/wrapped-icons/IconShareAndroid.js';
import '../Icon/wrapped-icons/IconShareIosActive.js';
import '../Icon/wrapped-icons/IconShareIos.js';
import '../Icon/wrapped-icons/IconShoppingCartActive.js';
import '../Icon/wrapped-icons/IconShoppingCart.js';
import '../Icon/wrapped-icons/IconShortcutsActive.js';
import '../Icon/wrapped-icons/IconShortcuts.js';
import '../Icon/wrapped-icons/IconSignatureLiveActive.js';
import '../Icon/wrapped-icons/IconSignatureLive.js';
import '../Icon/wrapped-icons/IconSort.js';
import '../Icon/wrapped-icons/IconStatusBubble.js';
import '../Icon/wrapped-icons/IconStatusConfirmationOndark.js';
import '../Icon/wrapped-icons/IconStatusConfirmationOnlight.js';
import '../Icon/wrapped-icons/IconStatusErrorOndark.js';
import '../Icon/wrapped-icons/IconStatusErrorOnlight.js';
import '../Icon/wrapped-icons/IconStatusIndeterminateThick.js';
import '../Icon/wrapped-icons/IconStatusIndeterminate.js';
import '../Icon/wrapped-icons/IconStatusInformationOndark.js';
import '../Icon/wrapped-icons/IconStatusInformationOnlight.js';
import '../Icon/wrapped-icons/IconStatusNoThick.js';
import '../Icon/wrapped-icons/IconStatusNo.js';
import '../Icon/wrapped-icons/IconStatusWarningOnamber.js';
import '../Icon/wrapped-icons/IconStatusWarningOndark.js';
import '../Icon/wrapped-icons/IconStatusWarningOnlight.js';
import '../Icon/wrapped-icons/IconStatusYesThick.js';
import '../Icon/wrapped-icons/IconStatusYes.js';
import '../Icon/wrapped-icons/IconSubtractCircleActive.js';
import '../Icon/wrapped-icons/IconSubtractCircle.js';
import '../Icon/wrapped-icons/IconSubtract.js';
import '../Icon/wrapped-icons/IconSurvey.js';
import '../Icon/wrapped-icons/IconSwitch.js';
import '../Icon/wrapped-icons/IconTaskActive.js';
import '../Icon/wrapped-icons/IconTask.js';
import '../Icon/wrapped-icons/IconTimeActive.js';
import '../Icon/wrapped-icons/IconTime.js';
import '../Icon/wrapped-icons/IconTouchContract.js';
import '../Icon/wrapped-icons/IconTouchDragDoubleFinger.js';
import '../Icon/wrapped-icons/IconTouchExpand.js';
import '../Icon/wrapped-icons/IconTouchSwipeDoubleFinger.js';
import '../Icon/wrapped-icons/IconTouchSwipeDown.js';
import '../Icon/wrapped-icons/IconTouchSwipeRight.js';
import '../Icon/wrapped-icons/IconTouchSwipeUp.js';
import '../Icon/wrapped-icons/IconTouchTapDoubleFinger.js';
import '../Icon/wrapped-icons/IconTouchTap.js';
import '../Icon/wrapped-icons/IconTradeActive.js';
import '../Icon/wrapped-icons/IconTradeFinanceActive.js';
import '../Icon/wrapped-icons/IconTradeFinance.js';
import '../Icon/wrapped-icons/IconTrade.js';
import '../Icon/wrapped-icons/IconTransferActive.js';
import '../Icon/wrapped-icons/IconTransferGlobalActive.js';
import '../Icon/wrapped-icons/IconTransferGlobal.js';
import '../Icon/wrapped-icons/IconTransfer.js';
import '../Icon/wrapped-icons/IconTravelActive.js';
import '../Icon/wrapped-icons/IconTravel.js';
import '../Icon/wrapped-icons/IconUpload.js';
import '../Icon/wrapped-icons/IconUserActive.js';
import '../Icon/wrapped-icons/IconUserMultipleActive.js';
import '../Icon/wrapped-icons/IconUserMultiple.js';
import '../Icon/wrapped-icons/IconUserStaffActive.js';
import '../Icon/wrapped-icons/IconUserStaff.js';
import '../Icon/wrapped-icons/IconUser.js';
import '../Icon/wrapped-icons/IconVideoActive.js';
import '../Icon/wrapped-icons/IconVideo.js';
import '../Icon/wrapped-icons/IconViewActive.js';
import '../Icon/wrapped-icons/IconViewAll.js';
import '../Icon/wrapped-icons/IconViewColumn.js';
import '../Icon/wrapped-icons/IconViewGrid.js';
import '../Icon/wrapped-icons/IconView.js';
import '../Icon/wrapped-icons/IconVoiceActive.js';
import '../Icon/wrapped-icons/IconVoice.js';
import '../Icon/wrapped-icons/IconVolumeHigh.js';
import '../Icon/wrapped-icons/IconVolumeLow.js';
import '../Icon/wrapped-icons/IconVolumeOff.js';
import '../Icon/wrapped-icons/IconWedding.js';
import '../Icon/wrapped-icons/IconWifiActive.js';
import '../Icon/wrapped-icons/IconWifi.js';
import '../Icon/wrapped-icons/IconVehicle.js';
import '../Icon/wrapped-icons/IconTick.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';

var ConditionalWrap = function ConditionalWrap(_ref) {
  var condition = _ref.condition,
      wrap = _ref.wrap,
      children = _ref.children;
  return condition ? wrap(children) : React.createElement(React.Fragment, null, children);
};

ConditionalWrap.propTypes = {
  condition: PropTypes.bool,
  wrap: PropTypes.func,
  children: PropTypes.node
};
var ButtonLinkBase = React.forwardRef(function (_ref2, ref) {
  var _cn, _cn2;

  var elementType = _ref2.elementType,
      component = _ref2.component,
      children = _ref2.children,
      external = _ref2.external,
      primaryButton = _ref2.primaryButton,
      iconSlotRight = _ref2.iconSlotRight,
      iconSlotLeft = _ref2.iconSlotLeft,
      target = _ref2.target,
      rel = _ref2.rel,
      _ref2$textMap = _ref2.textMap,
      textMap = _ref2$textMap === void 0 ? {
    newWindow: 'Opens in a new window'
  } : _ref2$textMap,
      restClassNames = _ref2.className,
      rest = _objectWithoutProperties(_ref2, ["elementType", "component", "children", "external", "primaryButton", "iconSlotRight", "iconSlotLeft", "target", "rel", "textMap", "className"]);

  var isAnchorElementAndExternal = !!(elementType === 'a' && external);
  var isButtonElementWithIcon = !!(elementType === 'button' && (iconSlotLeft || iconSlotRight));
  var variableProps = isAnchorElementAndExternal && {
    target: target || '_blank',
    rel: rel || 'noreferrer'
  }; // Defaults External Anchor Elements to have Open In New Window Icon in right hand slot.

  iconSlotRight = iconSlotRight || !iconSlotLeft && isAnchorElementAndExternal && !primaryButton && React.createElement(IconNewWindow, {
    inline: true
  });
  var Component = component || elementType;
  return React.createElement(Component, _extends({
    className: cn(restClassNames, (_cn = {}, _defineProperty(_cn, styles['anchor'], elementType === 'a'), _defineProperty(_cn, styles['hasMaxWidth'], isButtonElementWithIcon), _cn)),
    ref: ref
  }, variableProps, rest), React.createElement(ConditionalWrap, {
    condition: isButtonElementWithIcon,
    wrap: function wrap(children) {
      return React.createElement("span", {
        className: styles.flexContainer
      }, children);
    }
  }, iconSlotLeft && React.createElement("span", {
    "aria-hidden": "true",
    className: styles.iconLeft
  }, iconSlotLeft, "\uFEFF"), isButtonElementWithIcon ? React.createElement("span", {
    className: cn((_cn2 = {}, _defineProperty(_cn2, styles['buttonTextLeft'], iconSlotLeft), _defineProperty(_cn2, styles['buttonTextRight'], iconSlotRight), _cn2))
  }, children) : React.createElement(React.Fragment, null, children), isAnchorElementAndExternal && React.createElement(VisuallyHidden, null, " ", textMap.newWindow, " "), iconSlotRight && React.createElement("span", {
    "aria-hidden": "true",
    className: styles.iconRight
  }, "\uFEFF", iconSlotRight)));
});
ButtonLinkBase.displayName = 'ButtonLinkBase';
ButtonLinkBase.propTypes = process.env.NODE_ENV !== "production" ? {
  elementType: PropTypes.oneOf(['button', 'a']).isRequired,
  component: PropTypes.func,
  external: PropTypes.bool,
  primaryButton: PropTypes.bool,
  children: PropTypes.node,
  iconSlotLeft: PropTypes.node,
  iconSlotRight: PropTypes.node,
  target: PropTypes.string,
  rel: PropTypes.string,
  textMap: PropTypes.shape({
    newWindow: PropTypes.string
  }),
  className: PropTypes.string
} : {};
export default ButtonLinkBase;
export { ButtonLinkBase };